import * as React from 'react';
import { INotification } from '../../common/sharedTypes';
import { connect } from 'react-redux';
import { UserInfo } from '../Login/common/defaults';
import Form from 'react-bootstrap/Form';
import {
  Row,
  Col,
  Button,
  Modal,
  OverlayTrigger,
  Popover,
} from 'react-bootstrap';
import moment from 'moment';
import Accordion from 'react-bootstrap/Accordion';
import { Card } from 'react-bootstrap';
import { getCorrespondence } from './redux-objects/actions';
import '@fortawesome/fontawesome-free/css/all.css';
import 'font-awesome/css/font-awesome.css';
import * as urls from '../shared/urls';

const $ = require('jquery');
$.DataTable = require('datatables.net-bs4');

export interface ICorrespondencesViewProps {
  currentUser: UserInfo;
  reportId: number;
  crashKey?: string;
  reportCorrespondences: INotification[];
  getCorrespondence?: (url: string) => Promise<void>;
  onCloseModal?: () => void;
}

export interface ICorrespondencesViewState {}
const initialState: ICorrespondencesViewState = {};

class CorrespondencesView extends React.Component<
  ICorrespondencesViewProps,
  ICorrespondencesViewState
> {
  public constructor(props: ICorrespondencesViewProps) {
    super(props);
    this.state = initialState;
  }

  componentDidMount = () => {
    if (
      !this.props.reportCorrespondences ||
      this.props.reportCorrespondences.length == 0
    ) {
      this.props.getCorrespondence(
        urls.GET_NOTIFICATIONS_FOR_REPORT + '?reportId=' + this.props.reportId
      );
    }
  };

  onCloseViewModal = () => {
    this.setState({ showViewsId: null });
  };

  public render() {
    return (
      <div>
        <React.Fragment>
          <Modal
            show={true}
            onHide={this.props.onCloseModal}
            dialogClassName='modal-notification-template-edit'
          >
            <Modal.Header closeButton>
              <Modal.Title>Correspondence</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {this.props.reportCorrespondences &&
                this.props.reportCorrespondences.length > 0 && (
                  <Accordion defaultActiveKey='0'>
                    {this.props.reportCorrespondences &&
                      this.props.reportCorrespondences.map((n) => (
                        <Card
                          key={n.id.toString()}
                          className='notificationCard'
                        >
                          <Accordion.Toggle
                            as={Card.Header}
                            eventKey={n.id.toString()}
                            key={n.id.toString()}
                            className={
                              'accordianHeader ' +
                              (n.statusId == 2
                                ? 'lightyellow'
                                : n.statusId == 3
                                ? 'lightgreen'
                                : n.statusId == 4
                                ? 'lightred'
                                : '')
                            }
                          >
                            <React.Fragment>
                              <Row>
                                <Col>
                                  <strong>Template</strong>{' '}
                                  {n.notificationTemplate.name}
                                </Col>
                                <Col>
                                  <strong>Method:</strong>{' '}
                                  {n.notificationType.name}
                                </Col>
                                <Col>
                                  <strong>Status:</strong> {n.status.name}
                                </Col>
                              </Row>
                              <Row>
                                {n.statusId == 2 && (
                                  <Col>
                                    <strong>Queued For:</strong> {n.sendTo}
                                  </Col>
                                )}
                                {n.statusId == 3 && (
                                  <React.Fragment>
                                    <Col xs={8}>
                                      <strong>Sent To: </strong> {n.sendTo}
                                    </Col>
                                    <Col>
                                      <strong>On: </strong>
                                      {moment(n.sentDate).format('lll')}
                                    </Col>
                                  </React.Fragment>
                                )}
                              </Row>
                            </React.Fragment>
                          </Accordion.Toggle>
                          <Accordion.Collapse eventKey={n.id.toString()}>
                            <Card.Body>
                              <div
                                dangerouslySetInnerHTML={{ __html: n.body }}
                              />
                            </Card.Body>
                          </Accordion.Collapse>
                        </Card>
                      ))}
                  </Accordion>
                )}
              {(!this.props.reportCorrespondences ||
                this.props.reportCorrespondences.length == 0) && (
                <strong>No Correspondence</strong>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button variant='secondary' onClick={this.props.onCloseModal}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        </React.Fragment>
      </div>
    );
  }
}

export function mapStateToProps(state: any) {
  return {
    reportCorrespondences: state.Correspondence.reportCorrespondences,
    currentUser: state.Application.currentUser,
  };
}

const mapDispatchToProps = {
  getCorrespondence,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CorrespondencesView);
